import { render } from "./Mandats.vue?vue&type=template&id=3c2a0b44"
import script from "./Mandats.vue?vue&type=script&lang=js"
export * from "./Mandats.vue?vue&type=script&lang=js"

import "./Mandats.vue?vue&type=style&index=0&id=3c2a0b44&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__